import { createFileRoute } from "@tanstack/react-router";
import { CreditCard, Sparkles, QrCode } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/hero-card.webp";

export const Route = createFileRoute("/vi/platform/identity-and-sharing")({
  head: () => ({
    meta: [
      { title: "Danh tính & Chia sẻ — banana.cards" },
      { name: "description", content: "Thẻ kinh doanh số, sản phẩm NFC cao cấp và mọi kênh chia sẻ — QR, Wallet, link, signature email." },
      { property: "og:title", content: "Danh tính & Chia sẻ — banana.cards" },
      { property: "og:description", content: "Một danh tính, mọi kênh." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/identity-and-sharing", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Danh tính & Chia sẻ"
      title="Một danh tính,"
      italic="mọi kênh."
      description="Thẻ kinh doanh số đẹp, sản phẩm NFC cao cấp để chia sẻ chỉ một chạm, và mọi công cụ networking để biến cú chạm thành cuộc trò chuyện."
      heroImage={heroImg}
      features={[
        { title: "Thẻ kinh doanh số", desc: "Hồ sơ đẹp, tùy chỉnh cho mọi người trong team — với link, media và CTA.", href: "/vi/platform/cards", icon: CreditCard, bullets: ["Editor kéo thả", "Branding & theme tùy chỉnh", "Nhiều thẻ mỗi user"] },
        { title: "Thẻ NFC", desc: "Sản phẩm NFC cao cấp bằng kim loại, tre, PVC và vàng 24kt — bền và chạm để chia sẻ.", href: "/vi/platform/nfc", icon: Sparkles, bullets: ["6 chất liệu cao cấp", "Artwork tùy chỉnh", "Re-program bất cứ lúc nào"] },
        { title: "Chia sẻ & Networking", desc: "QR, Apple & Google Wallet, signature email, form trao đổi và bảo vệ PIN — mọi kênh chia sẻ.", href: "/vi/platform/sharing", icon: QrCode, bullets: ["6 công cụ networking", "Có analytics", "Apple & Google Wallet"] },
      ]}
      outro={{ title: "Danh tính của bạn, ", italic: "ở mọi nơi.", description: "Một hồ sơ, mọi thiết bị, mọi kênh — chia sẻ trong vài giây." }}
    />
  );
}